/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import { HELPERS } from '../../helpers/index.js';
import type { SetProposalVoteResponse, SetProposalVoteVars } from '../openapi-types.gen.js';

export type { SetProposalVoteResponse, SetProposalVoteVars } from '../openapi-types.gen.js';

export const useSetProposalVote = createMutationHook<SetProposalVoteVars, SetProposalVoteResponse, unknown>({
  specName: 'useSetProposalVote',
  path: '/v1/proposals/{pubkey}/vote',
  method: 'PUT',
  resolveUrl: (vars: SetProposalVoteVars) => `/v1/proposals/${vars.pubkey}/vote`,
  buildBody: (vars: SetProposalVoteVars) => ({ kind: vars.kind }),
  parseResponse: (raw: unknown): SetProposalVoteResponse => raw as SetProposalVoteResponse,
  optimistic: [{
    queryKey: ['proposals'],
    reconcile: false,
    entityGraph: true,
    apply: (prev: any, vars: SetProposalVoteVars, queryKey: readonly unknown[], queryClient: any) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyProposalVoteOptimistic as unknown as (prev: any, vars: SetProposalVoteVars, queryKey: readonly unknown[], queryClient: any) => any)(next, vars, queryKey, queryClient);
      return next;
    },
  }],
  
  
});
